import { AbstractDataClass, column } from '@/helpers/AbstractDataClass';
import { Smart } from '@/store/smart/types';

export interface AdminSite {
  _id?: string;
  name?: string;
  devices: Array<Smart>;
}

export interface AdminSiteState {
  adminSite?: AdminSite;
  dataAdminSite?: DataAdminSite[];
}

export class DataAdminSite extends AbstractDataClass<DataAdminSite>
  implements AdminSite {
  public _id: string;

  @column({
    label: 'Nom du site',
    placeholder: 'Nom du site',
    isArray: false,
    isSearchable: true,
  })
  public name?: string;

  @column({
    label: 'SmartTx',
    isArray: true,
    nameDropDown: 'Liste de SmartTx',
    name: 'name',
  })
  public devices: Array<Smart> = [];

  static fromJSON(object: AdminSite): DataAdminSite {
    let dataAdminSite = new DataAdminSite();
    dataAdminSite = Object.assign(dataAdminSite, object);
    return dataAdminSite;
  }
}
